export default __webpack_public_path__ + "static/media/malta.073544b9.png";